import { render } from "./ShowGiftcard.vue?vue&type=template&id=3b03d0de"
import script from "./ShowGiftcard.vue?vue&type=script&lang=js"
export * from "./ShowGiftcard.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__